// extracted by mini-css-extract-plugin
export default {"userIcon":"projectContentStyles_userIcon__SB+1u","userIconSvg":"projectContentStyles_userIconSvg__Wl9bt"};